import React from 'react';
import { motion } from 'framer-motion';
import GenericSvgLogo from '../../components/generic/Ganeric.svg-logo';

// Page transition consts
const transition = { duration: 0.75, ease: 'easeInOut' };
const variants = {
  initial: { scale: 1, x: '-50%', y: '-50%' },
  enter: { scale: 0, x: '-50%', y: '-50%', transition: { ...transition, delay: transition.duration + 0.5 } },
  exit: { scale: 1, x: '-50%', y: '-50%', transition: { ...transition } },
};

const onAnimationComplete = (e) => {
  if (e === 'exit') {
    window.scrollTo(0, 0);
    const el = document.querySelectorAll('.page-transition');
    if (el[0]) {
      el[0].style.display = 'flex';
    }
    if (el[1]) {
      el[1].style.display = 'flex';
    }
  }
};

const onAnimationStart = (e) => {
  const el = document.querySelectorAll('.page-transition');
  if (el[0]) {
    el[0].style.display = 'flex';
  }
  if (el[1]) {
    el[1].style.display = 'none';
  }
};

const Main = ({ children }) => {
  return (
    <>
      <motion.div
        key="overlay"
        className="page-transition"
        initial="initial"
        animate="enter"
        exit="exit"
        variants={variants}
        onAnimationComplete={onAnimationComplete}
        onAnimationStart={onAnimationStart}
        style={{
          position: 'fixed',
          justifyContent: 'center',
          alignItems: 'center',
          top: '50%',
          left: '50%',
          background: '#7d5d84',
          zIndex: 9999,
          borderRadius: '50%',
          width: 'calc(100vw + 80%)',
          height: 'calc(100vw + 80%)',
        }}
      >
        <GenericSvgLogo fillColour={'#fff'} />
      </motion.div>

      <main role="main">{children}</main>
    </>
  );
};

export default Main;
